export const PRODUCTS_LIST = 'PRODUCTS_LIST'
export const PRODUCTS_INFO = 'PRODUCTS_INFO'
export const PRODUCTS_VALIDATION = 'PRODUCTS_VALIDATION'
export const PRODUCTS_ADD = 'PRODUCTS_ADD'
